import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {CancellationInvoicesActions} from '../store';
import {CancellationInvoicesSelectors} from '../store/selectors';

@Injectable()
export class CancellationInvoicesLoadedGuard implements CanActivate {

  constructor(private store$: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.readCancellationInvoicesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  readCancellationInvoicesDone(): Observable<boolean> {

    return this.store$.pipe(
      select(CancellationInvoicesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          const params = {
            'order[createdAt]': 'desc'
          };
          this.store$.dispatch(CancellationInvoicesActions.ReadCancellationInvoices({page: 1, params}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
